var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcmIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9252 9.26665C17.9252 13.3416 14.9669 17.1583 10.9252 18.275C10.6502 18.35 10.3502 18.35 10.0752 18.275C6.03352 17.1583 3.0752 13.3416 3.0752 9.26665V5.6083C3.0752 4.92497 3.59187 4.14997 4.23354 3.89164L8.87519 1.99166C9.91685 1.56666 11.0919 1.56666 12.1335 1.99166L16.7752 3.89164C17.4085 4.14997 17.9335 4.92497 17.9335 5.6083L17.9252 9.26665Z",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcmIcon);
export default __webpack_public_path__ + "static/media/pcm_icon.fdee2f2d83a334db92b4d0291a5fbb4a.svg";
export { ForwardRef as ReactComponent };